module.exports = __webpack_public_path__ + "img/pocket waist seam.54fd40fb.png";